import CreditCardAdd from './credit-card-add';

export default CreditCardAdd;
